export default {
  pageNotExist: 'Trang web này không tồn tại, có thể bạn muốn chuyển tới trang khác',
  backToHome: 'Quay lại Trang chính',
  somethingWrong: 'Oops, Đã có lỗi xảy ra, vui lòng thử lại',
  pleaseChoosePackage: 'Vui lòng chọn Gói học trước, sau đó nhập thông tin chi tiết',
  selectPaymentMethod: 'Chọn Phương thức thanh toán',
  noPlanAvailable: 'Chưa cập nhật Gói học',
  selectPackage: 'Chọn Gói học',
  paymentSuccessful: 'THÀNH CÔNG',
  paymentFailed: 'THẤT BẠI',
  paymentCancelled: 'HỦY',
  packageName: 'Tên gói',
  service: 'Dịch vụ',
  serviceExpiryDate: 'Thời hạn tới',
  paymentDetails: 'Chi tiết thanh toán',
  termAndCondition: 'Điều khoản sử dụng',
  discountPriceSince: 'Giá được khấu trừ do bạn đã thanh toán trước đó ',
  originalAmount: 'Giá gói học',
  carryOverFee: 'Tiền giảm kì trước',
  total: 'Tổng',
  referenceNumber: 'Mã tham chiếu',
  paymentStatus: 'Tình trạng giao dịch',
  paymentMethod: 'Phương thức thanh toán',
  packagePlanDetail: 'Chi tiết gói học',
  payerDetail: 'Thông tin người thanh toán',
  cannotCreateOrder: 'Không thể đặt đơn hàng, vui lòng thử lại',
  cannotFindOrder: 'Không tìm thấy đơn hàng của bạn, vui lòng kiểm tra lại trên ứng dụng Manabie',
  statusOfPayment: 'Tình trạng giao dịch ',
  insufficientData: ', nhưng không thể hiển thị chính xác do thiếu thông tin. Vui lòng kiểm tra chi tiết trong Lịch sử thanh toán',
  payerName: 'Tên',
  payerPhoneNumber: 'Số điện thoại',
  cannotFindThisUser: 'Không tìm thấy thông tin của bạn, vui lòng kiểm tra Tình trạng giao dịch trong Lịch sử thanh toán',
  packagePlanName: 'Tên gói học',
  expiryDate: 'Ngày hết hạn',
  totalPayment: 'Tổng',
  paymentSummary: 'Tóm tắt thanh toán',
  backToApp: 'Quay lại ứng dụng',
  signIn: 'Đăng nhập',
  goToPayment: 'Thanh toán',
  oldOrderPending: 'Đã có lỗi xảy ra! Không thể thực hiện thanh toán do có giao dịch đang được xử lý. Vui lòng kiểm tra Lịch sử thanh toán',
  packagePeriod: 'Gói học bạn chọn có thời hạn ngắn hơn gói đang có hiệu lực',
  amountTooSmall: 'Giá trị thanh toán quá nhỏ.',
  packageNotFound: 'Không tìm thấy gói học được chọn',
  downgradeDuration: 'Hiện bạn không thể mua gói học thấp hơn gói đang có hiệu lực. Vui lòng liên hệ đội Chăm sóc Khách hàng của Manabie.',
  unknownError: 'Lỗi không xác định. Vui lòng thử lại. Xin cảm ơn!',
  notFound: 'Không tìm thấy chủ thể.',
  permissionDenied: 'Quyền truy cập bị từ chối. Có thể do bạn chưa đăng nhập.',
  internal: 'Lỗi máy chủ, xin vui lòng thử lại!',
  disconnectFromServer: 'Ngưng kết nối máy chủ, vui lòng kiểm tra kết nối mạng.',
  notAuthenticated: 'Phiên thanh toán của bạn đã hết hạn, hoặc do bạn chưa đăng nhập.',
  servicePeriod: 'Thời hạn tới',
  verify: 'Xác nhận',
  notThisAccount: 'Không phải tài khoản này',
  signOut: 'Đăng xuất',
  youSignInAs: 'Bạn đã đăng nhập tài khoản: ',
  goToPackage: 'Chọn Gói học',
  enterConfirmationCode: 'Nhập mã OTP của bạn',
  invalidConfirmationCode: 'Mã OTP không hợp lệ',
  recommended: 'Gợi ý',
  invalidPhoneNumber: 'Số điện thoại không hợp lệ',
  redirectToGateway: 'Đang đến cổng thanh toán',
  packageEnded: 'Gói học đã hết hạn',
  draftInvoice: 'Hóa đơn nháp',
  pleaseSignIn: 'Đăng nhập',
  weCanNotFindYourId: 'Không tìm thấy ID của bạn, vui lòng thử lại.',
  invalidCredential: 'Thông tin xác thực không hợp lệ, vui lòng thử Đăng xuất sau đó Đăng nhập lại',
  goBack: 'Quay lại',
  enterCode: 'Nhập mã',
  reducedBy: 'được giảm bởi code',
  apply: 'Sử dụng',
  promotion: 'Khuyến mãi (Không bắt buộc)',
  discount: 'Giảm giá',
  noInternet: 'Không có mạng',
  invalidPrams: 'Tham số không hợp lý',
  atmCard: 'Thẻ nội địa (ATM)',
  cod: 'Thanh toán khi nhận hàng',
  nationalWideDelivery: 'Giao hàng toàn quốc',
  ghnDesc: 'Vui lòng cung cấp chính xác thông tin địa chỉ, số điện thoại giao hàng. Sau khi bạn “Xác nhận thanh toán”, gói học của bạn sẽ được kích hoạt ngay lập tức. Nhân viên của GHN sẽ liên hệ với bạn để thu phí của gói học.',
  thisFieldIsRequired: 'Vui lòng điền thông tin này',
  fullName: 'Họ và tên',
  shippingAddress: 'Địa chỉ giao hàng',
  phoneNumber: 'Số điện thoại',
  city: 'Thành phố',
  district: 'Quận',
  ward: 'Phường/xã',
  pleaseFillForm: 'Vui lòng điền đầy đủ thông tin',
  confirmPayment: 'Xác nhận thanh toán',
  payerInfo: 'Thông tin người trả phí',
  thankYouForYourOrder: 'Cảm ơn bạn đã đặt hàng!',
  pleaseReadThisBefore: 'Vui lòng đọc kĩ lưu ý dưới đây trước khi Xác nhận',
  iHave: 'Tôi đã ',
  readAndAgreed: 'đọc và đồng ý ',
  uponAbove: 'các điều khoản trên.',
  close: 'Đóng',
  confirm: 'Xác nhận',
  codInstruct1: 'Gói học của bạn sẽ được kích hoạt ngay khi bạn nhấn “Xác nhận” cho thanh toán này.',
  codInstruct2: 'Nhân viên của GHN sẽ liên hệ với bạn để thu phí của Gói học trong vòng 5 ngày tới.',
  codInstruct3: 'Nếu bạn không thực hiện việc thanh toán, tài khoản của bạn sẽ bị hủy kích hoạt.',
  pleaseTickOnCheckbox: 'Vui lòng đánh dấu vào ô vuông để xác nhận',
  yourPaymentIsSuccessful: 'Giao dịch của bạn đã thành công.',
  enjoyLearningManabie: 'Enjoy your learning with Manabie.', //not translated
  yourPaymentIsFailed: 'Giao dịch của bạn đã thất bại.',
  pleaseTryAgain: 'Hãy thử lại.',
  back: 'Quay lại',
  payBefore: 'Trả trước ',
  at: 'lúc',
  processing: 'Đang xử lý',
  paymentInstruct1: 'Tài khoản của bạn đã được kích hoạt. Học tập thật vui bạn nhé!',
  paymentInstruct2: 'Trong vòng 5 ngày, nhân viên sẽ liên lạc và đến thu tiền tại nhà.',
  paymentInstruct3: 'Khi nhân viên đến nhà, thanh toán tiền mặt cho nhân viên và nhận một dãy số 8 ký tự tương đương như biên lai thu tiền.',
  paymentInstruct4: `Nếu cần trợ giúp, vui lòng liên hệ số ${process.env.SUPPORT_PHONE_NUMBER || '091-407-1517'}`,
  howToPay: 'Cách thanh toán',
  days: 'ngày',
  day: 'ngày',
  hours: 'giờ',
  hour: 'giờ',
  minutes: 'phút',
  minute: 'phút',
  goToSummary: 'Đến hóa đơn',
  expiringOn: 'Hết hạn ngày',
  visa: 'Visa/Mastercard',
  'you already have one order processing, can not create a new one': 'Xin lỗi, bạn đang có 1 đơn hàng đang xử lý, tạm thời chưa thể tạo đơn mới.',
  toDate: '{{day}} $t({{month}}) {{year}}',
  0: 'tháng 1',
  1: 'tháng 2',
  2: 'tháng 3',
  3: 'tháng 4',
  4: 'tháng 5',
  5: 'tháng 6',
  6: 'tháng 7',
  7: 'tháng 8',
  8: 'tháng 9',
  9: 'tháng 10',
  10: 'tháng 11',
  11: 'tháng 12',
  'Please enter promo code': 'Vui lòng nhập code',
  'This code has been entered incorrectly.': 'Code không hợp lệ.',
  'Sorry, this code has been expired.': 'Mã này đã hết hạn',
  PAYMENT_METHOD_NONE: 'NONE',
  PAYMENT_METHOD_ATM: 'ATM',
  PAYMENT_METHOD_CREDIT_DEBIT_CARD: 'CREDIT/DEBIT',
  PAYMENT_METHOD_COD: 'COD',
  PAYMENT_METHOD_BANK_TRANSFER: 'BANK TRANSFER',
  PAYMENT_METHOD_IAP: 'IN-APP PURCHASE',
  Master: undefined,
  missingUpgradeCondition: 'Bạn không thể mua gói học này, xin vui lòng liên hệ chúng tôi để được hỗ trợ',
  paymentProcessing: 'Đang xử lý',
  returnToPayment: 'Quay lại trang thanh toán',
  paymentDeleted: 'đã xóa',
  paymentTimeout: 'Giao dịch đã hết hạn, vui lòng tạo lại giao dịch mới',
  tryAgain2Time: 'Không thể đổi phương thực giao dịch 2 lần',
  rePurchasePayment: 'Bạn không thể mua đơn hàng này 2 lần',
  orderNotFound: 'Không tìm thấy đơn hàng',
  cannotParseToken: 'Dữ liệu đăng nhập không hợp lệ',
  userNotExist: 'Người dùng không tồn tại trong hệ thống, hãy đăng ký trong ứng dụng trước hoặc đăng nhập 1 tài khoản khác',
  'auth/account-exists-with-different-credential': 'Trùng email hoặc số điện thoại, Có phải trước đây bạn đăng ký bằng phương thức khác?',
  'auth/auth-domain-config-required': 'Lỗi hệ thống, tên miền chưa được điều chỉnh, xin hãy báo cho nhân viên của chúng tôi',
  'auth/cancelled-popup-request': '',
  'auth/operation-not-allowed': 'Tài khoản của bạn chưa được mở khóa, vui lòng liên hệ với nhân viên của chúng tôi',
  'auth/operation-not-supported-in-this-environment': 'Chỉ có thể đăng nhập nếu trình duyệt của bạn là hợp lệ',
  'auth/popup-blocked': 'Popup đăng nhập đã bị chặn',
  'auth/popup-closed-by-user': '',
  'auth/unauthorized-domain': 'Tên miền này chưa được xác thực',
  pleaseChooseYourPlan: 'Hãy chọn gói',
  enterYourPhoneNumber: 'Số điện thoại của bạn',
  socialSignOut: 'Tài khoản của bạn không tồn tại trong hệ thống',
  retry: 'Thử lại'
}
